// Reine Formatierungs-/Berechnungshelfer für die Trainingsdetail-Ansicht.

export const formatDate = (dateString) => {
    if (!dateString) return 'Kein Datum';
    return new Date(dateString).toLocaleDateString('de-DE', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
};

export const formatTime = (timeString) => {
    if (!timeString) return '';
    return new Date(timeString).toLocaleTimeString('de-DE', {
        hour: '2-digit',
        minute: '2-digit',
    });
};

export const calculateDuration = (start, end) => {
    if (!start || !end) return null;
    const startTime = new Date(start);
    const endTime = new Date(end);
    const diffMs = endTime - startTime;
    const diffMins = Math.round(diffMs / 60000);

    if (diffMins < 60) {
        return `${diffMins} Min`;
    }
    const hours = Math.floor(diffMins / 60);
    const mins = diffMins % 60;
    return `${hours}h ${mins}min`;
};
